export default {
  getSelectedTab: (state) => {
    return state.selectedTab;
  },
}
